/* src/components/Redireccionar.jsx */
import React from 'react';
// import { Link } from 'react-router-dom';  // ⇦ solo si vas a enlazar rutas internas
import PropTypes from 'prop-types';

export default function Redireccionar({ titulo, descripcion, imagen, enlace }) {
  return (
    <a
      href={enlace}
      className="group w-full max-w-[1400px] md:h-[200px] relative mx-auto overflow-hidden rounded-xl flex items-end hover:shadow-2xl transition duration-300 border-4 border-transparent hover:border-white"
      target="_blank"
      rel="noopener noreferrer"
    >
      {/* Texto superpuesto */}
      <div className="relative z-20 p-4 md:p-6 group-hover:-translate-y-2 transition duration-300">
        <h2 className="text-white text-base sm:text-lg md:text-xl font-bold uppercase group-hover:text-blue-400">
          {titulo}
        </h2>
        <p className="text-white text-sm mt-2 md:mt-4 lg:font-semibold">
          {descripcion}
        </p>
      </div>

      {/* Overlay azul */}
      <div className="absolute inset-0 bg-blue-950/30 z-10 group-hover:bg-opacity-10" />

      {/* Imagen de fondo */}
      <img
        src={imagen}
        alt="Redirección Andes-TEC"
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover rounded-lg"
      />
    </a>
  );
}

Redireccionar.propTypes = {
  titulo: PropTypes.string.isRequired,
  descripcion: PropTypes.string.isRequired,
  imagen: PropTypes.string.isRequired,
  enlace: PropTypes.string.isRequired,
};
